import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '..';

interface IDeleteIconProps extends IConDefaultType {}

function DeleteIcon({ color, className, size = 24, rotate, flip, style }: IDeleteIconProps) {
  const theme = useTheme();
  const fill = color || theme.color.icon.icon_3;

  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.35 21.9999H10.65C9.39832 22.005 8.19027 21.5402 7.26451 20.6973C6.33876 19.8545 5.76264 18.6949 5.65 17.4477L5 10.0841C4.98764 9.95258 5.00141 9.81995 5.04054 9.69381C5.07967 9.56768 5.14336 9.45054 5.22796 9.34916C5.31256 9.24778 5.41638 9.16416 5.53344 9.10312C5.6505 9.04209 5.77848 9.00484 5.91 8.99353C6.04143 8.98116 6.174 8.99495 6.30007 9.03409C6.42614 9.07324 6.54322 9.13697 6.64455 9.22161C6.74588 9.30624 6.82946 9.41012 6.89047 9.52724C6.95148 9.64436 6.9887 9.7724 7 9.90398L7.67 17.2876C7.73759 18.0359 8.08325 18.7317 8.63871 19.2374C9.19416 19.7431 9.919 20.022 10.67 20.0189H13.37C14.121 20.022 14.8458 19.7431 15.4013 19.2374C15.9567 18.7317 16.3024 18.0359 16.37 17.2876L17.04 9.92399C17.0513 9.79241 17.0885 9.66436 17.1495 9.54725C17.2105 9.43013 17.2941 9.32625 17.3955 9.24162C17.4968 9.15698 17.6139 9.09325 17.7399 9.0541C17.866 9.01496 17.9986 9.00117 18.13 9.01354C18.2615 9.02485 18.3895 9.0621 18.5066 9.12313C18.6236 9.18417 18.7274 9.26779 18.812 9.36917C18.8966 9.47055 18.9603 9.58769 18.9995 9.71382C19.0386 9.83996 19.0524 9.97259 19.04 10.1041L18.37 17.4677C18.2524 18.7148 17.6714 19.8723 16.7418 20.7115C15.8123 21.5507 14.602 22.0105 13.35 21.9999Z"
          fill={fill}
        />
        <path
          d="M10 16.0026C9.73478 16.0026 9.48043 15.8972 9.29289 15.7095C9.10536 15.5219 9 15.2674 9 15.0021V12.0006C9 11.7353 9.10536 11.4808 9.29289 11.2932C9.48043 11.1055 9.73478 11.0001 10 11.0001C10.2652 11.0001 10.5196 11.1055 10.7071 11.2932C10.8946 11.4808 11 11.7353 11 12.0006V15.0021C11 15.2674 10.8946 15.5219 10.7071 15.7095C10.5196 15.8972 10.2652 16.0026 10 16.0026Z"
          fill={fill}
        />
        <path
          d="M13.99 16.0026C13.7248 16.0026 13.4704 15.8972 13.2829 15.7095C13.0953 15.5219 12.99 15.2674 12.99 15.0021V12.0006C12.99 11.7353 13.0953 11.4808 13.2829 11.2932C13.4704 11.1055 13.7248 11.0001 13.99 11.0001C14.2552 11.0001 14.5096 11.1055 14.6971 11.2932C14.8846 11.4808 14.99 11.7353 14.99 12.0006V15.0021C14.99 15.2674 14.8846 15.5219 14.6971 15.7095C14.5096 15.8972 14.2552 16.0026 13.99 16.0026Z"
          fill={fill}
        />
        <path
          d="M20 6.00211H17.28L16.95 4.65144C16.7619 3.89242 16.3245 3.21856 15.708 2.73783C15.0916 2.25709 14.3316 1.99732 13.55 2.00014H10.5C9.71965 1.99781 8.96115 2.25795 8.34635 2.73878C7.73155 3.21962 7.29612 3.89323 7.11 4.65144L6.77 6.00211H4C3.73478 6.00211 3.48043 6.10752 3.29289 6.29515C3.10536 6.48277 3 6.73725 3 7.0026C3 7.26795 3.10536 7.52242 3.29289 7.71005C3.48043 7.89768 3.73478 8.00309 4 8.00309H20C20.2652 8.00309 20.5196 7.89768 20.7071 7.71005C20.8946 7.52242 21 7.26795 21 7.0026C21 6.73725 20.8946 6.48277 20.7071 6.29515C20.5196 6.10752 20.2652 6.00211 20 6.00211ZM8.78 6.00211L9 5.13168C9.0824 4.79964 9.27644 4.50606 9.54956 4.3002C9.82269 4.09435 10.1583 3.98875 10.5 4.00113H13.6C13.9337 3.99843 14.2585 4.10863 14.5217 4.31386C14.7849 4.51908 14.9711 4.80728 15.05 5.13168L15.27 6.00211H8.78Z"
          fill={fill}
        />
      </svg>
    </i>
  );
}

export default DeleteIcon;
